import React, { Suspense, lazy, useEffect } from "react";
import styled from "styled-components";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { initPixels } from "./lib/tracking";
import { HomePage } from "./pages/HomePage";
import { PrivacyPolicyPage } from "./pages/PrivacyPolicyPage";
import { TermsOfServicePage } from "./pages/TermsOfServicePage";
import { InstrumentSnapPrivacyPage } from "./pages/InstrumentSnapPrivacyPage";
import { InstrumentSnapTermsPage } from "./pages/InstrumentSnapTermsPage";
import { ConectaSoportePage } from "./pages/ConectaSoportePage";
import { ConectaPrivacidadPage } from "./pages/ConectaPrivacidadPage";
import { ConectaEliminarCuentaPage } from "./pages/ConectaEliminarCuentaPage";
import { TipShiftSupportPage } from "./pages/TipShiftSupportPage";
import { TipShiftPrivacyPage } from "./pages/TipShiftPrivacyPage";
import { CallPage } from "./pages/CallPage";
import { ThankYouPage } from "./pages/ThankYouPage";
import { isClientArea } from "./lib/client-area";

const BrandBriefPage = lazy(() => import('./client-briefs/BrandBriefPage').then(module => ({ default: module.BrandBriefPage })));
const AdminBriefPage = lazy(() => import('./client-briefs/AdminBriefPage').then(module => ({ default: module.AdminBriefPage })));

// Si se navega desde una pagina con pixeles ya cargados, primero hacemos una
// carga completa: el servidor entrega el area privada con su propia CSP.
function ClientAreaGate({ children }) {
  const reload = Boolean(window._monacoMetaPixelLoaded || window._monacoLiPixelLoaded);
  useEffect(() => {
    if (reload) window.location.reload();
  }, [reload]);
  return reload ? <p>Cargando espacio privado…</p> : <Suspense fallback={<p>Cargando formulario…</p>}>{children}</Suspense>;
}

const AppContainer = styled.div`
  font-family: "Roboto", sans-serif;
  color: #333;
`;

function App() {
  // Seguimiento solo en las paginas publicas, nunca en solicitudes de clientes.
  useEffect(() => {
    if (!isClientArea()) initPixels();
  }, []);

  return (
    <AppContainer>
      <Router>
        <Routes>
          <Route path="/clientes/marca" element={<ClientAreaGate><BrandBriefPage /></ClientAreaGate>} />
          <Route path="/clientes/solicitudes" element={<ClientAreaGate><AdminBriefPage /></ClientAreaGate>} />
          <Route path="/clientes/*" element={<p>Este enlace no corresponde a una solicitud. Pide a Mónaco el enlace completo.</p>} />
          <Route path="/" element={<HomePage />} />
          <Route path="/plantsnapai/privacy" element={<PrivacyPolicyPage />} />
          <Route path="/plantsnapai/terms" element={<TermsOfServicePage />} />
          <Route path="/instrumentsnap/privacy" element={<InstrumentSnapPrivacyPage />} />
          <Route path="/instrumentsnap/terms" element={<InstrumentSnapTermsPage />} />
          <Route path="/conecta/soporte" element={<ConectaSoportePage />} />
          <Route path="/conecta/privacidad" element={<ConectaPrivacidadPage />} />
          <Route path="/conecta/eliminar-cuenta" element={<ConectaEliminarCuentaPage />} />
          <Route path="/tipshift/support" element={<TipShiftSupportPage />} />
          <Route path="/tipshift/privacy" element={<TipShiftPrivacyPage />} />
          <Route path="/call" element={<CallPage />} />
          <Route path="/gracias-agenda" element={<ThankYouPage />} />
        </Routes>
      </Router>
    </AppContainer>
  );
}

export default App;
